var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asc__nextgrid" },
    [
      this.requiredFields &&
      this.requiredFields.length > 0 &&
      this.showRequiredInfo
        ? _c("span", [
            _vm._v(
              _vm._s(
                this.requiredFields
                  .map(function(x) {
                    return x.label
                  })
                  .join() +
                  " " +
                  _vm.$t("list.requiredFieldsMessage")
              )
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-table-simple",
        {
          staticClass: "asc__nextgrid-table",
          attrs: { hover: "", bordered: "", small: "", responsive: "" }
        },
        [
          _c(
            "b-thead",
            [
              _c(
                "draggable",
                {
                  attrs: {
                    tag: "tr",
                    list: _vm.head,
                    disabled: _vm.disabledDraggable || _vm.mobileDragDisabled
                  }
                },
                _vm._l(_vm.head, function(header) {
                  return _c(
                    "b-th",
                    {
                      key: header.dataField + header.columnType,
                      class:
                        header.align == null
                          ? "asc__nextgrid-table-header asc__nextgrid-table-header-" +
                            header.columnType +
                            " text-left"
                          : "asc__nextgrid-table-header asc__nextgrid-table-header-" +
                            header.columnType +
                            " text-" +
                            header.align,
                      style: header.minLength
                        ? "min-width: " + header.minLength + "px"
                        : ""
                    },
                    [
                      header.columnType === "selection"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allSelected,
                                expression: "allSelected"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.allSelected)
                                ? _vm._i(_vm.allSelected, null) > -1
                                : _vm.allSelected
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectAll()
                              },
                              change: function($event) {
                                var $$a = _vm.allSelected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allSelected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allSelected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allSelected = $$c
                                }
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "asc__nextgrid-table-header-title grid-wrap-text"
                        },
                        [
                          _vm._v(
                            _vm._s(header.label) +
                              _vm._s(
                                header.label && header.required ? "*" : ""
                              ) +
                              "\n            "
                          ),
                          header.columnType !== "operations" &&
                          header.columnType !== "selection"
                            ? _c(
                                "span",
                                {
                                  staticClass: "asc__nextgrid-table-header-sort"
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "py-0",
                                      attrs: { size: "sm", variant: "light" },
                                      on: {
                                        click: function($event) {
                                          return _vm.sortable(
                                            header.dataField,
                                            _vm.sortableColumns[
                                              header.dataField
                                            ] === "ASC"
                                              ? "DESC"
                                              : "ASC",
                                            header.columnType
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          _vm.sortableColumns[
                                            header.dataField
                                          ] === "ASC"
                                            ? "fas fa-sort-up"
                                            : "fas fa-sort-down"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "asc__nextgrid-table-header-filter" },
                        [
                          header.modelControlUtil != null
                            ? _c("div", [
                                header.modelControlUtil.InputType ===
                                "AutoComplete"
                                  ? _c(
                                      "div",
                                      [
                                        _c("autocomplete", {
                                          ref: "AutoCompleteDropdown",
                                          refInFor: true,
                                          staticClass: "autocomplete-search",
                                          attrs: {
                                            search: _vm.onAutoCompleteSearch,
                                            "get-result-value":
                                              _vm.getResultValue,
                                            disabled:
                                              _vm.disabledAutoComplete ||
                                              header.disabled
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickAutoComplete(
                                                header
                                              )
                                            },
                                            focus: function($event) {
                                              _vm.disabledDraggable = true
                                            },
                                            blur: function($event) {
                                              _vm.disabledDraggable = false
                                            },
                                            submit: function($event) {
                                              return _vm.handleSubmit(
                                                header.modelControlUtil
                                                  .ModelProperty,
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "result",
                                                fn: function(ref) {
                                                  var result = ref.result
                                                  var props = ref.props
                                                  return [
                                                    _c(
                                                      "li",
                                                      _vm._b(
                                                        {},
                                                        "li",
                                                        props,
                                                        false
                                                      ),
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getResultValue(
                                                                result
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        header.modelControlUtil.IsLookupTable
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Label",
                                                options:
                                                  _vm.lookup[
                                                    header.modelControlUtil.Code
                                                  ],
                                                disabled: header.disabled
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.selectedValue(
                                                    header.modelControlUtil
                                                      .ModelProperty,
                                                    $event,
                                                    header.columnType ===
                                                      "DropDownCode"
                                                      ? "code"
                                                      : "lookup"
                                                  )
                                                },
                                                focus: function($event) {
                                                  _vm.disabledDraggable = true
                                                },
                                                blur: function($event) {
                                                  _vm.disabledDraggable = false
                                                }
                                              },
                                              model: {
                                                value: header.defaultValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    header,
                                                    "defaultValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "header.defaultValue"
                                              }
                                            })
                                          : _c("v-select", {
                                              attrs: {
                                                label: "Description1",
                                                options:
                                                  _vm.gridField[
                                                    header.modelControlUtil
                                                      .ModelProperty
                                                  ],
                                                disabled: header.disabled
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.selectedValue(
                                                    header.modelControlUtil
                                                      .ModelProperty,
                                                    $event,
                                                    "search"
                                                  )
                                                },
                                                focus: function($event) {
                                                  _vm.disabledDraggable = true
                                                },
                                                blur: function($event) {
                                                  _vm.disabledDraggable = false
                                                }
                                              },
                                              model: {
                                                value: header.defaultValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    header,
                                                    "defaultValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "header.defaultValue"
                                              }
                                            })
                                      ],
                                      1
                                    )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "Boolean"
                            ? _c("v-select", {
                                attrs: {
                                  options: _vm.searchBoolean,
                                  label: "title",
                                  disabled: header.disabled
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filterBoolean(header)
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "Date"
                            ? _c("date-picker", {
                                attrs: {
                                  range: "",
                                  type: "date",
                                  placeholder: _vm.getFormattedDate(
                                    header.defaultValue
                                  ),
                                  format: "YYYY-MM-DD",
                                  "value-type": "format",
                                  disabled: header.disabled
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.filterRangeDate(
                                      header.dataField,
                                      header.defaultValue,
                                      header.columnType
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "DateTime"
                            ? _c("date-picker", {
                                attrs: {
                                  range: "",
                                  type: "date",
                                  placeholder: _vm.getFormattedDate(
                                    header.defaultValue
                                  ),
                                  format: "YYYY-MM-DD",
                                  "value-type": "format",
                                  disabled: header.disabled
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.filterRangeDate(
                                      header.dataField,
                                      header.defaultValue,
                                      header.columnType
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "DateTime2"
                            ? _c("b-form-datepicker", {
                                attrs: {
                                  placeholder: "",
                                  disabled: header.disabled
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filterDate(
                                      header.dataField,
                                      header.defaultValue
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "Time"
                            ? _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "##:##:##",
                                    expression: "'##:##:##'"
                                  }
                                ],
                                attrs: {
                                  placeholder: "00:00:00",
                                  disabled: header.disabled
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.filterTime(
                                      header.dataField,
                                      header.defaultValue
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "String"
                            ? _c("b-form-input", {
                                attrs: { disabled: header.disabled },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchOnTable(
                                      header.dataField,
                                      header.defaultValue
                                    )
                                  },
                                  input: function($event) {
                                    return _vm.setSearchQ(
                                      header.dataField,
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "Decimal"
                            ? _c("b-form-input", {
                                attrs: {
                                  type: "number",
                                  disabled: header.disabled
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.filterDecimal(
                                      header.dataField,
                                      header.defaultValue
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          header.columnType === "Id"
                            ? _c("b-form-input", {
                                attrs: { disabled: header.disabled },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchOnTable(
                                      header.dataField,
                                      header.defaultValue
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.disabledDraggable = true
                                  },
                                  blur: function($event) {
                                    _vm.disabledDraggable = false
                                  }
                                },
                                model: {
                                  value: header.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(header, "defaultValue", $$v)
                                  },
                                  expression: "header.defaultValue"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tbody",
            _vm._l(_vm.items, function(item, i) {
              return _c(
                "b-tr",
                {
                  key: i,
                  class:
                    item.Selected || _vm.allSelected
                      ? "row-selected"
                      : "" || _vm.selectionMode === "multi"
                      ? "multi-hover-class"
                      : "",
                  attrs: {
                    id: item.RecordId,
                    variant: _vm.otherDispatchListLength
                      ? _vm.updateRowAfterMultiPrint(item.RecordId, "color")
                      : ""
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.selectRow(item)
                    }
                  }
                },
                [
                  _vm.isItemInDispatchList(item.RecordId)
                    ? _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: String(item.RecordId),
                            position: "bottom"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.updateRowAfterMultiPrint(
                                  item.RecordId,
                                  "message"
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.head, function(h) {
                    return _c("b-td", { key: h.dataField + h.columnType }, [
                      h.columnType === "selection"
                        ? _c("span", { staticClass: "d-block w-100" }, [
                            _vm.selectionMode === "multi"
                              ? _c("i", {
                                  staticClass: "fa fa-check-circle",
                                  class:
                                    item.Selected || _vm.allSelected
                                      ? "selected-color"
                                      : "unselected-color"
                                })
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      h.columnType === "operations"
                        ? _c(
                            "span",
                            { staticClass: "d-block w-100" },
                            [
                              _vm.tableOperations.RowActions.length >= 1
                                ? _c(
                                    "b-dropdown",
                                    {
                                      staticClass:
                                        "asc__nextgrid-dropdown-btn-p0",
                                      attrs: {
                                        size: "sm",
                                        variant: "default",
                                        "no-caret": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "button-content",
                                            fn: function() {
                                              return [
                                                _c("i", {
                                                  staticClass: "fas fa-th"
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("Actions", {
                                        attrs: {
                                          actions: _vm.filterRowActions(
                                            _vm.tableOperations.RowActions,
                                            item
                                          ),
                                          row: item
                                        },
                                        on: { showModal: _vm.showModal }
                                      }),
                                      _vm._v(" "),
                                      _vm.visibleWorkFlow(item)
                                        ? _c("Workflow", {
                                            attrs: {
                                              items: _vm.workFlowList,
                                              RecordId: item.RecordId
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : h.columnType === "LabelValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item[h.dataField],
                                  "Label"
                                )
                              }
                            },
                            [
                              _vm.getLabelValueFormat(item, h)
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getLabelValueFormat(item, h)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                : h.label == "Durum"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "w-100 d-block text-center"
                                      },
                                      [_c("i", { class: _vm.iconClass(item) })]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        : h.columnType === "CodeValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item[h.dataField],
                                  "Code"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(item[h.dataField], "Code")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "UpperValueValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.abelFormat(
                                  item[h.dataField],
                                  "UpperValue"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(
                                      item[h.dataField],
                                      "UpperValue"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "ValueValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item[h.dataField],
                                  "Value"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(item[h.dataField], "Value")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "DecimalValueValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item[h.dataField],
                                  "DecimalValue"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(
                                      item[h.dataField],
                                      "DecimalValue"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "OtherPropertiesValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item[h.dataField],
                                  "OtherProperties"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(
                                      item[h.dataField],
                                      "OtherProperties"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "Boolean"
                        ? _c(
                            "span",
                            { staticClass: "w-100 d-block text-center" },
                            [
                              _c("i", {
                                class:
                                  item[h.dataField] === 1
                                    ? "fas fa-check text-success"
                                    : "fas fa-times text-danger"
                              })
                            ]
                          )
                        : h.columnType === "Date"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.dateFormat(item[h.dataField])
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.dateFormat(item[h.dataField])) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "DateTime"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.dateTimeformat(item[h.dataField])
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.dateTimeformat(item[h.dataField])
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "DateTime2"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.dateTimeformat(item[h.dataField])
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.dateTimeformat(item[h.dataField])
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "String"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: { title: item[h.dataField] }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item[h.dataField]) +
                                  "\n          "
                              )
                            ]
                          )
                        : h.columnType === "Id"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: { title: item[h.dataField] }
                            },
                            [_c("i", [_vm._v(_vm._s(item[h.dataField]))])]
                          )
                        : h.columnType === "DescriptionValue"
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: {
                                title: _vm.labelFormat(
                                  item["Label" + h.dataField],
                                  "Description1"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.labelFormat(
                                      item["Label" + h.dataField],
                                      "Description1"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "d-block w-100 grid-wrap-text",
                              attrs: { title: item[h.dataField] }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item[h.dataField]) +
                                  "\n          "
                              )
                            ]
                          )
                    ])
                  })
                ],
                2
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.items && _vm.items.length > 0
        ? _c(
            "b-row",
            { staticClass: "asc__nextgrid-table-footer" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-dropdown",
                    {
                      attrs: {
                        text: _vm.perPage + " / " + _vm.totalRowCount,
                        size: "sm"
                      }
                    },
                    _vm._l(_vm.perPageOpt, function(p) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: "perpage" + p,
                          attrs: { "active-class": "dropdown-active" },
                          on: {
                            click: function($event) {
                              return _vm.setPerPage(p)
                            }
                          }
                        },
                        [_vm._v(_vm._s(p))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination-nav", {
                    staticClass: "float-right asc__nextgrid-paginationlinks",
                    attrs: {
                      pills: "",
                      "link-gen": _vm.linkGen,
                      "number-of-pages": _vm.totalPageCount,
                      "use-router": "",
                      variant: "dark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "RejectModal",
          attrs: {
            id: "approve-reject-modal",
            "hide-footer": "",
            "hide-header": ""
          }
        },
        [
          _c("PotentialCustomerRejectModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "ApproveModal",
          attrs: { id: "approve-modal", "hide-footer": "", "hide-header": "" }
        },
        [
          _vm.showPotentialCustomerApproveModal
            ? _c("PotentialCustomerApproveModal", {
                attrs: {
                  modalAction: _vm.modalAction,
                  modalItem: _vm.modalItem
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "LocationModal",
          attrs: { id: "location-modal", "hide-footer": "", "hide-header": "" }
        },
        [
          _vm.showLocationModal
            ? _c("NextLocation", { attrs: { Location: _vm.modalItem } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showConfirmModal
        ? _c("ConfirmModal", {
            attrs: {
              modalAction: _vm.modalAction,
              modalItem: _vm.modalItem,
              "after-action": _vm.afterAction
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCustomConvertModal
        ? _c("CustomConvertModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showConvertModal
        ? _c("OrderConvertModal", {
            attrs: {
              openModal: _vm.showConvertModal,
              modalAction: _vm.modalAction,
              modalItem: _vm.modalItem
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWaybillConvertModal
        ? _c("SalesWaybillConvertModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRmaConvertModal
        ? _c("RmaConvertModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRmaInvoiceModal
        ? _c("RmaInvoiceModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showInvoiceConvertModal
        ? _c("InvoiceConvertModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showKmModal
        ? _c("KmModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateSalesWaybillModal
        ? _c("CreateSalesWaybill", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMultipleLoadingPlanModal
        ? _c("MultipleLoadingPlanModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showUpdateCreditBudgetModal
        ? _c("UpdateCreditBudgetModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showBudgetMasterApproveModal
        ? _c("BudgetMasterApproveModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAssignEmployeeModal
        ? _c("AssignEmployeeModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCommonInfoModal
        ? _c("CommonInfoModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEFULogModal
        ? _c("EFULogModal", {
            attrs: { modalAction: _vm.modalAction, modalItem: _vm.modalItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreditBulkBudgetModal
        ? _c("CreditBudgetBulkApproveModal", {
            attrs: {
              modalAction: _vm.modalAction,
              modalItem: _vm.modalItem,
              size: "xl"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06c236ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c236ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextGrid.vue
// module id = null
// module chunks = 